module.exports = ".align-buttons {\n  text-align: right; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/master/master-checklist-maintenance/master-checklist-maintenance.component.scss
// module id = ./src/app/master/master-checklist-maintenance/master-checklist-maintenance.component.scss
// module chunks = main